"use client";

import { Search } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState, type FormEvent } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Input,
} from "@/components/ui";

export default function OrderLookupPage() {
  const router = useRouter();
  const [orderNumber, setOrderNumber] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    const num = orderNumber.trim();
    const mail = email.trim();

    if (!num) {
      setError("Please enter your order number.");
      return;
    }
    if (!mail) {
      setError("Please enter your email address.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
      setError("Please enter a valid email address.");
      return;
    }

    setError("");
    router.push(`/order/${num}?email=${encodeURIComponent(mail)}`);
  }

  return (
    <Container className="py-12" data-testid="order-lookup-page">
      <div className="mx-auto max-w-md">
        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <Search className="text-gold-500 h-5 w-5" />
              <h1 className="text-ink-900 text-lg font-semibold">
                Track Your Order
              </h1>
            </div>
            <p className="text-ink-500 mt-1 text-sm">
              Enter your order number and the email used at checkout to view
              your order details and tracking status.
            </p>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit} className="space-y-3" noValidate>
              <div>
                <label
                  htmlFor="lookup-number"
                  className="text-ink-700 mb-1.5 block text-sm font-medium"
                >
                  Order number
                </label>
                <Input
                  id="lookup-number"
                  value={orderNumber}
                  onChange={(e) => setOrderNumber(e.target.value)}
                  placeholder="e.g. ZYL-2026-000001"
                  data-testid="lookup-number"
                />
              </div>
              <div>
                <label
                  htmlFor="lookup-email"
                  className="text-ink-700 mb-1.5 block text-sm font-medium"
                >
                  Email
                </label>
                <Input
                  id="lookup-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  data-testid="lookup-email"
                />
              </div>
              {error && (
                <p className="text-danger text-xs" data-testid="lookup-error">
                  {error}
                </p>
              )}
              <Button
                type="submit"
                className="w-full"
                data-testid="lookup-submit"
              >
                Track Order
              </Button>
            </form>
          </CardBody>
        </Card>
      </div>
    </Container>
  );
}
